import { render, staticRenderFns } from "./sensitive-words.vue?vue&type=template&id=6663d2d6"
import script from "./sensitive-words.vue?vue&type=script&lang=ts"
export * from "./sensitive-words.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports